import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatBoxComponent } from './components/chat-box/chat-box.component';
import { ChatIconComponent } from './components/chat-icon/chat-icon.component';
import { TelespotChatDataAccessModule } from '@telespot/chat/data-access';

import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { FormatTextPipeModule } from '@telespot/shared/util';
@NgModule({
  imports: [
    CommonModule,
    TelespotChatDataAccessModule,
    FormsModule,
    TranslateModule,
    FormatTextPipeModule,
  ],
  declarations: [ChatBoxComponent, ChatIconComponent],
  exports: [ChatBoxComponent, ChatIconComponent],
})
export class TelespotChatFeatureModule { }
